import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";

// Configurar interceptor de axios para incluir token automáticamente
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta con responseType arraybuffer/blob
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Suppress the console error for arraybuffer/blob responses
    // The actual error handling is done in the component
    if (error.config?.responseType === 'arraybuffer' || error.config?.responseType === 'blob') {
      // Don't log to console to avoid the overlay in development
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
